import React from 'react';
import PropTypes from 'prop-types';
import { FDBodyText } from '@facet-wealth/design';

const BodyList = ({ value, size }) => {
  return (
    <ul>
      {value.map((v) => (
        <li><FDBodyText value={v} size={size} /></li>
      ))}
    </ul>
  );
};


BodyList.defaultProps = {
  size: 'md',
};

BodyList.propTypes = {
  value: PropTypes.string.isRequired,
  size: PropTypes.string,
};

export default BodyList;
